import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useCats } from './hooks/useCats';
import Navbar from './components/Navbar';
import CatList from './components/CatList';
import AddCat from './components/AddCat';
import EditCat from './components/EditCat';
import CatDetails from './components/CatDetails';
import './App.css';

function App() {
  const { cats, addCat, updateCat, deleteCat } = useCats();

  return (
    <BrowserRouter>
      <div className="App">
        <Navbar />
        <div className="container">
          <Routes>
            <Route 
              path="/" 
              element={<CatList cats={cats} onDelete={deleteCat} />} 
            />
            <Route 
              path="/add" 
              element={<AddCat onAdd={addCat} />} 
            />
            <Route 
              path="/edit/:id" 
              element={<EditCat cats={cats} onUpdate={updateCat} />} 
            />
            <Route 
              path="/cat/:id" 
              element={<CatDetails cats={cats} />} 
            />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
